<template>
	<PointsHistoryDialog v-model="open" :overlay-target="overlayTarget" :filter="filter" />
	<v-snackbar v-model="earnedSnackbar" :timeout="5000" rounded="xl" color="success">
		{{ t('YouEarn') + ' ' + earnedPoints + ' ' + t('Points').toLowerCase() }}
	</v-snackbar>
</template>

<script setup>
import { ref, inject, onMounted, onBeforeUnmount } from 'vue';
import PointsHistoryDialog from './PointsHistoryDialog.vue';
import { fireConfettiBurst } from '@/utils/confettiEffects';
import { eventBus } from '@/utils/eventBus';
import { useTranslator } from '@/utils/useTranslator';

const t = useTranslator();
const overlayTarget = inject('overlayTarget', null);
const open = ref(false);
const filter = ref(null);
const earnedSnackbar = ref(false);
const earnedPoints = ref(0);

function handleOpen(event) {
	filter.value = event?.detail ?? null;
	open.value = true;
}

// RG #22908: fires regardless of which view/dialog is currently open — this zone is
// persistent (mounted once right after main sync, never torn down by view changes).
function handleScoreClaimValidated(data) {
	fireConfettiBurst(0.5);
	earnedPoints.value = data?.pointsValidated ?? 0;
	earnedSnackbar.value = true;
}

onMounted(() => {
	window.addEventListener('open-vue-points-dialog', handleOpen);
	eventBus.on('score-claim-validated', handleScoreClaimValidated);
});

onBeforeUnmount(() => {
	window.removeEventListener('open-vue-points-dialog', handleOpen);
	eventBus.off('score-claim-validated', handleScoreClaimValidated);
});
</script>
